import { Dossier } from '@sc/data-access-models';

export class SetDossiersRequestedAppointmentAction {
  static readonly type = '[SetDossiersRequestedAppointmentAction] Set dossiers';

  constructor(public payload: Dossier[]) {}
}

export class SetNewDossierRequestedAppointmentAction {
  static readonly type =
    '[SetNewDossierRequestedAppointmentAction] Set new dossier';

  constructor(public payload: Dossier) {}
}

export class ReplaceDossiersRequestedAppointmentAction {
  static readonly type =
    '[ReplaceDossiersRequestedAppointmentAction] Replace dossiers';

  constructor(public payload: Dossier[]) {}
}
